import { GetProductDetailsParams } from 'types/services';
import { ProductDetails } from 'types/state';
import { m8API } from 'services/production/m8';
import { normalizeM8CalculationComponent } from 'services/production/utils/normalizeM8CalculationComponent';
import { UnexpectedError } from 'utils/errors';
import { normalizeM8Price } from 'services/production/utils/normalizeM8Price';

export const getProductDetails = async (
  params: GetProductDetailsParams
): Promise<ProductDetails> => {
  const calculationComponents = await m8API.admin.getCalculationComponents();

  const targetComponent = calculationComponents.find(
    (component) => component.id === params.productId
  );

  if (!targetComponent) {
    throw new UnexpectedError();
  }

  const componentPricesAll = await m8API.admin.getComponentPrices({
    type: targetComponent.productType,
  });

  let componentPrices = componentPricesAll;

  if (targetComponent.lastPrice) {
    const lastPriceId = targetComponent.lastPrice.id;

    componentPrices = componentPricesAll.filter(
      (price) => price.id !== lastPriceId
    );
  }

  const product = normalizeM8CalculationComponent(targetComponent).toProduct();

  const archivedTariffs = componentPrices
    .sort((priceA, priceB) => {
      // Производится сортировка по дате создания. Новые элементы массива дожны идти первыми.
      return (
        new Date(priceB.createdOn).getTime() -
        new Date(priceA.createdOn).getTime()
      );
    })
    .map((tariff) => normalizeM8Price(tariff).toTariff());

  return {
    product,
    archivedTariffs,
  };
};
